import { useEffect, useState } from "react";
import WebLayout from "../layout/WebLayout";
import { useSelector } from "react-redux";
import { useSearchProductFetch } from "../hooks/useSearchProductFetch";
import SearchProductCard from "../components/SearchProductCard";
import { PRODUCT_NOT_FOUND } from "../utils/Constants";

function SearchProduct() {
  const { searchProducts } = useSelector((state) => state.product);
  const { isLoading, hasMore } = useSearchProductFetch();
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setInitialLoadComplete(true);
    }
  }, [isLoading]);

  return (
    <WebLayout pageName="Search Product">
      <section className="shop py-20">
        <div className="container container-lg">
          <div className="row">
            <div className="col-md-12">
              {isLoading && searchProducts.length === 0 ? (
                <div className="flex justify-content-center text-center">
                  <i
                    className="fa fa-spinner fa-spin fa-4x"
                    style={{ color: "#299e60" }}
                  />
                </div>
              ) : searchProducts.length > 0 ? (
                <>
                  <SearchProductCard searchProducts={searchProducts} />

                  {isLoading && (
                    <div className="flex justify-content-center text-center mt-3">
                      <i
                        className="fa fa-spinner fa-spin fa-2x"
                        style={{ color: "#299e60" }}
                      />
                    </div>
                  )}

                  {!isLoading && !hasMore && searchProducts.length > 0 && (
                    <div className="text-center mt-3">
                      <p>You've reached the end</p>
                    </div>
                  )}
                </>
              ) : initialLoadComplete ? (
                <div className="text-center py-5">
                  <img
                    src={PRODUCT_NOT_FOUND}
                    alt="Product Not Found"
                    className="img-fluid"
                    style={{ maxHeight: "300px", borderRadius: "50%" }}
                  />
                  <h5 className="mt-3 text-muted">No products found</h5>
                  <p>Try adjusting your search or filters</p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    </WebLayout>
  );
}

export default SearchProduct;
